module.exports = __webpack_public_path__ + "img/8spades.052ac25e.jpg";